<div class="ds-accordion-separator" [ngClass]="'ds-border-color--'+ borderColor">
  <ngb-accordion
    #acc="ngbAccordion"
    class="ds-accordion-item"
    [attr.aria-activedescendant]="accordionId"
    [class.ds-accordion-small]="small"
    [class.ds-accordion-indented]="indented">
    <ngb-panel [id]="accordionId">
      <ng-template ngbPanelHeader let-opened="opened">
        <button
          #panelToggle
          ngbPanelToggle
          [attr.data-cy]="accordionId"
          class="btn btn-link text-start w-100 focusable"
          [class.px-5]="indented"
          [class.mt-3]="opened"
          [class.margin-outline]="!indented"
          role="button">
          <h3 class="d-flex align-items-center focusable__element mb-0">
            <em
              class="ds-icon ds-icon--big ds-icon--{{acc.isExpanded(accordionId) ? 'arrow-up' : 'arrow-down'}} me-{{small ? '3' : '4'}}"></em>
            <span [ngClass]="(small) ? 'ds-heading--xs ds-font--medium':'ds-heading--s'"
                  class="ds-color--blue">{{header}}</span>
          </h3>
        </button>
      </ng-template>
      <ng-template ngbPanelContent>
        <section class="ds-accordion-content{{small ? '--small mt-3' : ''}}" [class.margin-outline]="!indented">
          <ng-content></ng-content>
        </section>
      </ng-template>
    </ngb-panel>
  </ngb-accordion>
</div>
